module.exports = __webpack_public_path__ + "img/logo-dark.70fb6521.png";